import { v4 as uuidv4 } from "uuid";

/**
 * @returns A Uuid with the V4 shape
 */
export function generateId(): string {
  return uuidv4();
}
